import React, { useState } from 'react';
import {
  IonGrid,
  IonRow,
  IonLabel,
  IonInput,
  IonRadioGroup,
  IonRadio,
  IonItem,
  IonList,
  IonButton,
  IonCol,
  IonImg,
  IonCheckbox
} from '@ionic/react';
import { LogOutContainer } from '../../containers/LogOutContainer';
import {
  carrierMcNo,
  carrierUsDotNo,
  REGISTER_LABEL,
  REGISTER_LABEL_DESKTOP,
  REGISTER_PLACEHOLDER_DESKTOP,
  ALL_FIELDS_REQUIRED_TEXT,
  RegisterForm
} from '../../utils/constants';
import i18n from '../../../i18n';
import ParkLocation from '../../utils/ParkLocation';
import MobileNumber from '../../utils/MobileNumber/MobileNumber';

export const RegistrationFormDesktop = (props: any) => {
  
  const [showDropDown,setShowDropDown] = useState(false);
  return (
    <>
      <div className="registration-page">
        <IonImg src="assets/icon/sni-Logo.png" className="logo" />
        <IonGrid class="titel-grid"> {i18n.t(REGISTER_LABEL.createProfile)}</IonGrid>
        <IonList class="registration-form">
          <IonRow className="fields-required-row">
            <IonCol className="registration-form-col">{i18n.t(ALL_FIELDS_REQUIRED_TEXT)}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="registration-form-col">
              <IonGrid class="select-role-grid">
                <IonRow class="select-role-label">{i18n.t(REGISTER_LABEL_DESKTOP.role)}</IonRow>
                  <IonGrid class="role-suggetion-grid">
                      {props.role.map((roles: any, index: number) => (
                        <IonRow
                          key={index}
                          class={"opt-row"}
                        >
                          <IonCheckbox
                              data-test="roleOption"
                              class="checkbox-desktop"
                              checked={props.role[index].selected}
                              onIonChange={e => props.optionClicked(roles)}
                            />
                          <IonCol class="role-column">
                            <IonLabel>{" "}{i18n.t(roles.label)}</IonLabel>
                            <IonRow class="role-desc">{i18n.t(roles.desc)}</IonRow>
                          </IonCol>
                        </IonRow>
                      ))}
                    </IonGrid>
                </IonGrid> 
              <IonGrid class="errorGrid">{i18n.t(props.roleError)}</IonGrid>
              <IonItem mode="ios">
                <IonLabel mode="ios" position="floating">
                  {i18n.t(REGISTER_LABEL_DESKTOP.firstName)}
                </IonLabel>
                <IonInput
                  type="text"
                  name="firstName"
                  pattern="[A-Za-z]"
                  placeholder={i18n.t(REGISTER_PLACEHOLDER_DESKTOP.firstName)}
                  value={props.firstName}
                  onIonChange={event => props.handleValueChange(event)}
                  onBlur={event => props.validateFeilds(event)}
                  onIonBlur={(event:any)=> props.handleValueChange(event)}
                  data-test='firstName'
                />
              </IonItem>
              <IonGrid class="errorGrid">
                {i18n.t(props.firstNameError)}
              </IonGrid>
              <IonItem mode="ios">
                <IonLabel mode="ios" position="floating">
                  {i18n.t(REGISTER_LABEL_DESKTOP.lastName)}
                </IonLabel>
                <IonInput
                  type="text"
                  name="lastName"
                  placeholder={i18n.t(REGISTER_PLACEHOLDER_DESKTOP.lastName)}
                  onIonChange={event => props.handleValueChange(event)}
                  pattern="[A-Za-z]"
                  value={props.lastName}
                  onBlur={event => props.validateFeilds(event)}
                  onIonBlur={(event:any)=> props.handleValueChange(event)}
                  data-test='lastName'
                />
              </IonItem>
              <IonGrid class="errorGrid">
                {i18n.t(props.lastNameError)}
              </IonGrid>
              <MobileNumber
                mobileNumber={props.mobileNumber}
                mobileReadOnly={props?.isMFA ? true: false}
                handleValueChange={props.handleValueChange}
                validateFeilds={props.validateFeilds}
                name={RegisterForm.mobileNumber}
                placeholder={i18n.t(REGISTER_PLACEHOLDER_DESKTOP.mobileNumber)}
                label={i18n.t(REGISTER_LABEL_DESKTOP.phoneNumber)}
                onIonBlur={(event:any)=> props.handleValueChange(event)}
                mobileValidateError={props.mobileValidateError}
                mobileValidation={props.mobileValidation}   
                onFocus={props.onFocus}  
                isMobile={false}
                showDropDown={showDropDown}
                setShowDropDown={setShowDropDown}
                countryCode={props.countryCode}           
                nonEditableField={props?.isMFA ? true: false}        
              />
              {showDropDown ?
                <IonGrid className="drop-grid" >
                  {props.dropDownValues.map((code: any) => {
                    return <IonRow
                      onClick={() => {
                        props.onChangeCountryCode(Object.values(code).toString());
                        props.onChangePayloadCountryCode(Object.keys(code).toString());
                        setShowDropDown(false);
                      }}
                    > {Object.values(code).toString()} </IonRow>
                  })}
                </IonGrid> : null
              }
              {props.mobileValidateError ? (
              <IonGrid class="errorGrid">
                {i18n.t(props.mobileNumberError)}
              </IonGrid>
              ) : null }
              {props.isDriverSelected &&
                <ParkLocation value={props.addressDTOs} handleValueChange={props.handleValueChange} />
              }
            </IonCol>
            <IonCol className="registration-col">
              <IonItem mode="ios">
                <IonLabel mode="ios" position="floating">
                  {i18n.t(REGISTER_LABEL_DESKTOP.company)}
                </IonLabel>
                <IonInput
                  type="text"
                  name="companyName"
                  placeholder={i18n.t(REGISTER_PLACEHOLDER_DESKTOP.companyName)}
                  onIonChange={event => props.handleValueChange(event)}
                  value={props.companyName}
                  onBlur={event => props.validateFeilds(event)}
                  onIonBlur={(event:any)=> props.handleValueChange(event)}
                  data-test='companyName'
                />
              </IonItem>
              <IonGrid class="errorGrid">{i18n.t(props.companyNameError)}</IonGrid>
              <IonItem mode="ios">
                <IonLabel mode="ios" position="floating">
                  {i18n.t(REGISTER_LABEL_DESKTOP.zipcode)}
                </IonLabel>
                <IonInput
                  type="text"
                  name="corporateZipCode"
                  placeholder={i18n.t(REGISTER_PLACEHOLDER_DESKTOP.zipcode)}
                  onIonChange={event => props.handleValueChange(event)}
                  pattern="[A-Za-z]"
                  value={props.corporateZipCode}
                  onBlur={event => props.validateFeilds(event)}
                  onIonBlur={(event:any)=> props.handleValueChange(event)}
                  data-test="corporateZipCode"
                />
              </IonItem>
              <IonGrid class="errorGrid">{i18n.t(props.zipcodeEror)}</IonGrid>
              <IonItem mode="ios">
                <IonRow class="ion-align-self-stretch">
                  <IonCol class="company-col">
                    <IonLabel mode="ios" position="floating">
                      {i18n.t(REGISTER_LABEL_DESKTOP.usdotOrMc)}
                    </IonLabel>
                  </IonCol>
                  <IonCol class="company-col ion-align-self-center">
                    <IonRadioGroup
                      onIonChange={event => props.handleValueChange(event)}
                      name="slectedNo"
                      value={props.slectedNo}>
                      <IonRow class="ion-text-right radio-btn-section">
                        <IonCol size="7">
                          <IonRadio value={carrierUsDotNo} class="radiobutton" mode="md" />
                          <span>{i18n.t(REGISTER_LABEL_DESKTOP.USDOT)}</span>
                        </IonCol>
                        <IonCol size="5">
                          <IonRadio value={carrierMcNo} class="radiobutton" mode="md" />
                          <span>{i18n.t(REGISTER_LABEL_DESKTOP.MC)}</span>
                        </IonCol>
                      </IonRow>
                    </IonRadioGroup>
                  </IonCol>
                </IonRow>
                <IonInput
                  type="text"
                  name="USDOTNO"
                  placeholder={i18n.t(props.placeHolderText)}
                  onIonChange={event => props.handleValueChange(event)}
                  maxlength={8}
                  value={props.USDOTNO}
                  onBlur={event => props.validateFeilds(event)}
                  onIonBlur={(event:any)=> props.handleValueChange(event)}
                  data-test='USDOTNO'
                />
              </IonItem>
              <IonGrid class="errorGrid">{i18n.t(props.usDotError)}</IonGrid>
              {props.isDriverSelected &&
                <>
                  <IonItem mode="ios">
                    <IonLabel mode="ios" position="floating">
                      {i18n.t(REGISTER_LABEL.tractorNumber)}
                    </IonLabel>
                    <IonInput
                      type="text"
                      name={RegisterForm.tractorNumber}
                      placeholder={i18n.t(REGISTER_PLACEHOLDER_DESKTOP.tractorNumber)}
                      onIonChange={event => props.handleValueChange(event)}
                      value={props.tractorNumber}
                      onBlur={event => props.validateFeilds(event)}
                      data-test="tractorNumber"
                      maxlength={15}
                    />
                  </IonItem>
                  <IonGrid class={`errorGrid ${props.tractorNumberError ? 'showErrorGrid' : ''}`} >
                    {i18n.t(props.tractorNumberError)}
                  </IonGrid>
                </>
              }
            </IonCol>
          </IonRow>
          <div className="bottom-grid">
            <IonRow class="bottom-grid-row">
              <IonCol>
                <LogOutContainer {...props} isRegistrationPage={true} />
              </IonCol>
              <IonCol>
                <IonButton
                  expand="full"
                  disabled={!props.allowToSave}
                  className={`${props.allowToSave ? 'active-btn' : 'register-btn'}`}
                  onClick={props.submitForm}
                  data-test="registerButton">
                  {i18n.t(REGISTER_LABEL_DESKTOP.saveProfile)}
                </IonButton>
              </IonCol>
            </IonRow>
          </div>
        </IonList>
      </div>
    </>
  )
}
